<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		fill="currentColor"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 344.996 344.996"
		xml:space="preserve"
	>
		<path
			d="M172.498,70.839C77.159,70.839,0,147.989,0,243.337c0,4.143,3.358,7.5,7.5,7.5c3.327,0,132.584,0,135.105,0 c3.359,13.381,15.485,23.32,29.893,23.32c14.408,0,26.534-9.939,29.893-23.32c2.501,0,131.682,0,135.105,0 c4.142,0,7.5-3.357,7.5-7.5C344.996,147.999,267.846,70.839,172.498,70.839z M179.997,86.013L179.997,86.013 c36.765,1.712,71.235,15.99,98.442,40.776c-13.327,13.327-13.14,13.14-26.362,26.361c-20.03-17.732-45.234-28.203-72.08-29.855 V86.013z M164.997,86.013v37.282h0.001c-26.423,1.628-51.656,11.796-72.08,29.855c-13.203-13.202-13.024-13.024-26.362-26.361 C93.763,102.003,128.233,87.725,164.997,86.013z M15.174,235.837c1.712-36.765,15.989-71.235,40.775-98.441l26.362,26.361 c-17.216,19.459-28.163,44.448-29.856,72.08H15.174z M172.498,259.157c-8.723,0-15.82-7.097-15.82-15.82 c0-8.724,7.097-15.82,15.82-15.82c8.596,0,15.82,7.117,15.82,15.82C188.318,252.061,181.221,259.157,172.498,259.157z M197.018,224.69c-1.767-2.32-3.631-4.137-5.874-5.872l19.25-13.377L197.018,224.69z M207.538,235.837l38.951-56.052 c4.752-6.837-3.612-15.186-10.438-10.439l-62.169,43.202c-14.924-0.659-27.784,9.397-31.282,23.289H67.492 c3.872-55.03,49.599-97.77,105.006-97.77c55.609-0.001,101.154,43.03,105.006,97.77H207.538z M292.54,235.837 c-1.635-26.782-12.07-51.963-29.856-72.08l26.362-26.361c24.786,27.206,39.064,61.676,40.775,98.441H292.54z"
		></path>
	</svg>
</div>
